import { useSiteContent } from '@/context/SiteContentContext';
import ImageUploadField from './ImageUploadField';

export default function AdminServicesTab() {
  const { content, updateContent } = useSiteContent();
  const services = content.services;

  return (
    <div className="space-y-8">
      <h3 className="text-lg font-bold text-gray-900 border-b border-gray-100 pb-3">Services Section</h3>

      {services.map((svc, i) => (
        <div key={i} className="bg-gray-50 rounded-xl p-5 border border-gray-100">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-teal-100">
              <i className={`${svc.icon} text-teal-600 text-sm`}></i>
            </div>
            <span className="font-bold text-gray-800 text-sm">Service {i + 1}: {svc.title}</span>
          </div>

          <ImageUploadField
            label="Service Image"
            value={svc.image}
            onChange={(v) => updateContent(`services.${i}.image`, v)}
          />

          <div className="grid grid-cols-2 gap-3 mb-3">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Category</label>
              <input
                type="text"
                value={svc.category}
                onChange={(e) => updateContent(`services.${i}.category`, e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Title</label>
              <input
                type="text"
                value={svc.title}
                onChange={(e) => updateContent(`services.${i}.title`, e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="block text-xs font-semibold text-gray-600 mb-1">Description</label>
            <textarea
              value={svc.description}
              rows={2}
              onChange={(e) => updateContent(`services.${i}.description`, e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white resize-none"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-2">Bullet Points (one per line)</label>
            <textarea
              value={svc.items.join('\n')}
              rows={5}
              onChange={(e) => updateContent(`services.${i}.items`, e.target.value.split('\n').filter(Boolean))}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white resize-none font-mono"
            />
          </div>
        </div>
      ))}
    </div>
  );
}
